import React, { useState, useEffect } from "react";
import UploadPhoto from "../../Assets/images/UploadPhoto.svg";
import "../../Assets/styles/newStyles/AddDoctorDialog.css";
import ApiService from "../../Services/ApiServices";
import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";
import ClipLoader from "react-spinners/ClipLoader";
import history from "../../history";
export const AddDoctorDialog = (props) => {
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isSuccessDialogOpen, setisSuccessDialogOpen] = useState(false);
  const [createdDoctorName, setCreatedDoctorName] = useState("");
  const [loader, setLoader] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const [formData, setFormData] = useState({
    firstname: "",
    salutation: "Dr.",
    lastname: "",
    email: "",
    contact: "",
    password: "",
    hospitals: "",
    qualifications: "",
    postalCode: "",
    city: "",
    state: "",
    country: "",
  });
  const [email, setEmail] = useState("")

  useEffect(() => {
    setDialogOpen(props.open);
    document.body.style.overflow = props.open ? "hidden" : "unset";
  }, [props.open]);

  const closeDialog = () => {
    if (props.onClose) {
      setEmail(formData.email)
      setFormData({
        firstname: "",
        salutation: "Dr.",
        lastname: "",
        email: "",
        contact: "",
        password: "",
        hospitals: "",
        qualifications: "",
        postalCode: "",
        city: "",
        state: "",
        country: "",
      });
      setSelectedFile(null);
      setErrorMessage("");
      setisSuccessDialogOpen(false);
      setDialogOpen(false);
      props.onClose();
    }
  };

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleInputChange = (event) => {
    const { id, value } = event.target;
    setFormData({
      ...formData,
      [id]: value,
    });
  };

  const goHome = () => {
    history.push('/doctorsList'); 
    window.location.reload(); 
  };

  function generatePassword(length = 8) {
    const charset =
      "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789@-_";
    let password = "";

    // Ensure at least one special character from the allowed set
    const specialCharset = "@-_";
    password +=
      specialCharset[Math.floor(Math.random() * specialCharset.length)];

    // Generate the rest of the characters
    for (let i = 1; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charset.length);
      password += charset[randomIndex];
    }

    // Shuffle the password to avoid predictable placement of the special character
    password = password
      .split("")
      .sort(() => 0.5 - Math.random())
      .join("");
    // Retry generation until a valid password is created
    while (!isPasswordValid(password)) {
      password = generatePassword(length);
    }

    return password;
  }

  // Validation function
  function isPasswordValid(password) {
    const minLength = 8;
    const pattern = /^[a-zA-Z0-9@-_]*$/;
    const hasSpecialChar = /[@_-]/.test(password); // Ensure at least one special character

    return (
      password.length >= minLength && pattern.test(password) && hasSpecialChar
    );
  }

  const handleSave = async () => {
    try {
      setLoader(true);
      if (!isPasswordValid(formData.password)) {
        setErrorMessage(
          "Password must be at least 8 characters long and contain at least one special character."
        );
        setLoader(false);
        return;
      }

      const formPayload = new FormData();
      formPayload.append("firstname", formData.firstname);
      formPayload.append("salutation", formData.salutation);
      formPayload.append("lastname", formData.lastname);
      formPayload.append("email", formData.email);
      formPayload.append("contact", formData.contact);
      formPayload.append("password", formData.password);
      formPayload.append("hospitals", formData.hospitals);
      formPayload.append("city", formData.city);
      formPayload.append("state", formData.state);
      formPayload.append("country", formData.country);
      formPayload.append("qualifications", formData.qualifications);
      formPayload.append("postalCode", formData.postalCode);

      if (selectedFile) {
        formPayload.append("profileImage", selectedFile);
      }

      const apiService = new ApiService();
      const response = await apiService.addDoctor(formData);
      if (response.status === "Success") {
        setCreatedDoctorName(
          `${formData.salutation} ${formData.firstname} ${formData.lastname}`
        );
        closeDialog();
        setisSuccessDialogOpen(true);
        console.log("Doctor added successfully:", response.message);
      } else {
        setErrorMessage(response.message);
      }
    } catch (error) {
      console.error("Error adding doctor:", error);
      setErrorMessage(
        error.message ||
          "An error occurred while adding the doctor. Please try again."
      );
    } finally {
      setLoader(false);
    }
  };

  const handleViewProfile = () => {
    history.push(`/doctorDetails/${email}`);
  };

  return (
    <>
      {isDialogOpen && (
        <>
          {/* Grey-out overlay */}
          <div className="dialog-overlay"></div>
          <div className={`doctordialog ${isDialogOpen ? "open" : ""}`}>
            {loader ? (
              <div className="loadingdiv">
                <ClipLoader color={"#007bff"} loading={loader} size={30} />
              </div>
            ) : (
              <>
                <div className="doctordialog-title">
                  <h2 className="doctordialog-heading">Add Doctor</h2>
                  <p className="close-button" onClick={closeDialog}>
                    Close
                  </p>
                </div>
                <div className="doctordialog-content">
                  <div className="mandatory-content-container">
                    {/* Upload Photo Section */}
                    <div className="upload-section">
                      <input
                        accept="image/*"
                        style={{ display: "none" }}
                        id="upload-photo"
                        type="file"
                        onChange={handleFileChange}
                      />
                      {selectedFile && (
                        <img
                          src={URL.createObjectURL(selectedFile)}
                          alt="Profile Preview"
                          className="profile-preview"
                        />
                      )}
                      <label htmlFor="upload-photo" className="upload-button">
                        <img src={UploadPhoto} alt="Upload" />
                      </label>
                      {/* <button className="upload-photo-button">Upload Photo</button> */}
                    </div>

                    {/* Mandatory Fields Section */}
                    <div className="fields-section">
                      <h3 className="mandatory-header">Mandatory Fields</h3>
                      <div className="name-fields">
                        <div className="field-container full-width">
                          <label htmlFor="firstname" className="field-label">
                            First Name
                          </label>
                          <div className="flex-container">
                            <select
                              id="salutation"
                              className="select-field"
                              value={formData.salutation}
                              style={{ width: "44%" }}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  salutation: e.target.value,
                                })
                              }
                            >
                              <option value="Dr.">Dr.</option>
                              <option value="Mr.">Mr.</option>
                              <option value="Ms.">Ms.</option>
                              <option value="Mrs.">Mrs.</option>
                            </select>

                        <input
                          id="firstname"
                          type="text"
                          placeholder="First Name"
                          className="input-field input-large"
                          value={formData.firstname}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^[a-zA-Z\s]*$/.test(value)) {
                              setFormData({ ...formData, firstname: value });
                              setErrorMessage("");
                            } else {
                              setErrorMessage(
                                "Only alphabets and spaces are allowed."
                              );
                            }
                          }}
                        />
                      </div>
                    </div>

                    <div className="field-container full-width">
                      <label htmlFor="lastname" className="field-label">
                        Last Name
                      </label>
                      <input
                        id="lastname"
                        type="text"
                        placeholder="Last Name"
                        className="input-field"
                        value={formData.lastname}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^[a-zA-Z\s]*$/.test(value)) {
                            setFormData({ ...formData, lastname: value });
                            setErrorMessage("");
                          } else {
                            setErrorMessage(
                              "Only alphabets and spaces are allowed."
                            );
                          }
                        }}
                      />
                    </div>
                  </div>

                  <div className="flex-space-between">
                    <div className="field-container half-width">
                      <label htmlFor="email" className="field-label">
                        Email
                      </label>
                      <input
                        id="email"
                        type="email"
                        placeholder="Enter Email"
                        className="input-field full-width"
                        value={formData.email}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="field-container half-width">
                      <label htmlFor="contact" className="field-label">
                        Contact
                      </label>
                      <PhoneInput
                        country={"in"}
                        value={formData.contact}
                        onChange={(phone) =>
                          setFormData({
                            ...formData,
                            contact: phone.startsWith("+")
                              ? phone
                              : `+${phone}`,
                          })
                        }
                        inputStyle={{
                          color: "#243757",
                          fontSize: "11px",
                          width: "100%",
                        }}
                        placeholder="Enter Contact"
                        countryCodeEditable={false}
                        enableSearch
                      />
                    </div>
                  </div>

                  <div className="field-container large-width">
                    <label htmlFor="password" className="field-label">
                      Password
                    </label>
                    <div className="flex-container">
                      <input
                        id="password"
                        type="text"
                        placeholder="Enter or Click Generate"
                        className="input-field full-width"
                        style={{ width: "48%" }}
                        value={formData.password}
                        onChange={handleInputChange}
                      />
                      <button
                        className="generate-button"
                        onClick={() => {
                          const generatedPassword = generatePassword(8);
                          setFormData({
                            ...formData,
                            password: generatedPassword,
                          });
                          setIsDisabled(true);
                        }}
                        disabled={isDisabled}
                        style={{
                          backgroundColor: isDisabled ? "#ccc" : "#FFE5B4",
                          color: isDisabled ? "#000" : "#000",
                          cursor: isDisabled ? "not-allowed" : "pointer",
                        }}
                      >
                        {isDisabled ? "Generated" : "Generate"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

                  <h3 className="optional-header">Optional Fields</h3>
                  <div className="name-fields">
                    <div className="field-container half-width">
                      <label htmlFor="hospitals" className="field-label">
                        Hospital
                      </label>
                      <input
                        id="hospitals"
                        type="text"
                        placeholder="Enter Hospital Name"
                        className="input-field"
                        value={formData.hospitals}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^[a-zA-Z\s]*$/.test(value)) {
                            setFormData({ ...formData, hospitals: value });
                            setErrorMessage("");
                          } else {
                            setErrorMessage(
                              "Only alphabets and spaces are allowed."
                            );
                          }
                        }}
                      />
                    </div>
                    <div className="field-container half-width">
                      <label htmlFor="qualifications" className="field-label">
                        Qualification
                      </label>
                      <input
                        id="qualifications"
                        type="text"
                        placeholder="Enter Qualification"
                        className="input-field"
                        value={formData.qualifications}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^[a-zA-Z\s]*$/.test(value)) {
                            setFormData({ ...formData, qualifications: value });
                            setErrorMessage("");
                          } else {
                            setErrorMessage(
                              "Only alphabets and spaces are allowed."
                            );
                          }
                        }}
                      ></input>
                    </div>
                  </div>

                  <div className="select-container">
                    <div className="field-container half-width">
                      <label htmlFor="city" className="field-label">
                        City
                      </label>
                      <input
                        id="city"
                        type="text"
                        placeholder="Enter City"
                        className="input-field"
                        value={formData.city}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^[a-zA-Z\s]*$/.test(value)) {
                            setFormData({ ...formData, city: value });
                            setErrorMessage("");
                          } else {
                            setErrorMessage(
                              "Only alphabets and spaces are allowed."
                            );
                          }
                        }}
                      />
                    </div>
                    <div className="field-container half-width">
                      <label htmlFor="state" className="field-label">
                        State
                      </label>
                      <input
                        id="state"
                        type="text"
                        placeholder="Enter State"
                        className="input-field"
                        value={formData.state}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^[a-zA-Z\s]*$/.test(value)) {
                            setFormData({ ...formData, state: value });
                            setErrorMessage("");
                          } else {
                            setErrorMessage(
                              "Only alphabets and spaces are allowed."
                            );
                          }
                        }}
                      ></input>
                    </div>
                  </div>

                  <div className="flex-space-between">
                    <div className="field-container half-width">
                      <label htmlFor="country" className="field-label">
                        Country
                      </label>
                      <input
                        id="country"
                        type="text"
                        placeholder="Enter Country"
                        className="input-field"
                        value={formData.country}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^[a-zA-Z\s]*$/.test(value)) {
                            setFormData({ ...formData, country: value });
                            setErrorMessage("");
                          } else {
                            setErrorMessage(
                              "Only alphabets and spaces are allowed."
                            );
                          }
                        }}
                      />
                    </div>
                    <div className="field-container half-width">
                      <label htmlFor="Postal Code" className="field-label">
                        Postal Code
                      </label>
                      <input
                        id="postalCode"
                        type="text"
                        placeholder="Enter Postal Code"
                        className="input-field"
                        value={formData.postalCode}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d*$/.test(value)) {
                            setFormData({ ...formData, postalCode: value });
                            setErrorMessage("");
                          } else {
                            setErrorMessage(
                              "Only numbers are allowed."
                            );
                          }
                        }}
                      />
                    </div>
                  </div>

                  {/* Error Message Display */}
                  {errorMessage && (
                    <div className="error-message">{errorMessage}</div>
                  )}

                  <div className="submit-section">
                    <button className="submit-button" onClick={handleSave}>
                      Save & Create Doctor Profile
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        </>
      )}

      {isSuccessDialogOpen && (
        <>
          {/* Grey-out overlay */}
          <div className="dialog-overlay"></div>
          <div className="success-dialog">
            <div className="success-title-container">
              <h3 className="success-title">New Doctor Profile Created</h3>
              <div className="success-line"></div>
            </div>

            <div className="success-doctor-name">
              <p>{createdDoctorName}</p>
            </div>

            <div className="success-actions-container">
              <button
                className="view-profile-button"
                onClick={handleViewProfile}
              >
                View Profile
              </button>
              <p className="go-home-text" onClick={goHome}>
                Go Home
              </p>
            </div>
          </div>
        </>
      )}
    </>
  );
};
